export default __webpack_public_path__ + "static/media/youtube.59781f1d.svg";